module.exports = __webpack_public_path__ + "static/media/logo2.47b17167.svg";